import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "remote-monitoring-event-item" }
const _hoisted_2 = { class: "remote-monitoring-event-item__info" }
const _hoisted_3 = { class: "remote-monitoring-event-item__meta" }
const _hoisted_4 = { class: "label-mono-m" }
const _hoisted_5 = { class: "remote-monitoring-event-item__camera-meta label-m" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "remote-monitoring-event-item__dot" }, null, -1)
const _hoisted_7 = { class: "remote-monitoring-event-item__confidence" }
const _hoisted_8 = {
  key: 1,
  class: "remote-monitoring-event-item__no-card heading-3xl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NDateTimeLabel = _resolveComponent("NDateTimeLabel")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NThumbnail = _resolveComponent("NThumbnail")!
  const _component_Confidence = _resolveComponent("Confidence")!
  const _component_CardItemTile = _resolveComponent("CardItemTile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_NDateTimeLabel, {
          modelValue: _ctx.item.external_timestamp,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.external_timestamp) = $event)),
          size: "m"
        }, null, 8, ["modelValue"]),
        _createElementVNode("span", _hoisted_4, "#" + _toDisplayString(_ctx.item.id), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createTextVNode(_toDisplayString(_ctx.item.camera), 1),
        _hoisted_6,
        _createTextVNode(_toDisplayString(_ctx.item.puppet_id), 1)
      ]),
      (!_ctx.item.acknowledged)
        ? (_openBlock(), _createBlock(_component_NButton, {
            key: 0,
            type: "secondary",
            onClick: _ctx.acknowledge
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('remote_monitoring.acknowledge', 'f')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_NThumbnail, {
      size: "semi-small",
      class: "remote-monitoring-event-item__event",
      "model-value": _ctx.item.thumbnail,
      onClick: _ctx.showItemImage
    }, null, 8, ["model-value", "onClick"]),
    (_ctx.hasCard)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Confidence, {
              direction: "vertical",
              value: _ctx.item.confidence
            }, null, 8, ["value"])
          ]),
          (_ctx.card)
            ? (_openBlock(), _createBlock(_component_CardItemTile, {
                key: 0,
                item: _ctx.card,
                type: "humans",
                "model-acl": _ctx.modelAcl,
                confidence: _ctx.item.confidence,
                textComment: _ctx.reasons,
                "show-more": false,
                selected: !!_ctx.multisidebarModule.getItem(_ctx.pageSidebarType, _ctx.card.id),
                opened: _ctx.getIsCardOpened(_ctx.card),
                showConnections: _ctx.card.has_case_cluster && _ctx.isShowConnections,
                showInteractions: false,
                onSelect: _cache[1] || (_cache[1] = () => _ctx.multisidebarModule.addItemAndOpen(_ctx.pageSidebarType, _ctx.card)),
                onClickOnImage: _ctx.showCardImage,
                ref: "card"
              }, null, 8, ["item", "model-acl", "confidence", "textComment", "selected", "opened", "showConnections", "onClickOnImage"]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('remote_monitoring.unmatched', 'u')), 1))
  ]))
}